/** @jsx jsx */
import React, { Fragment as _, useEffect } from 'react';
import { css, jsx } from '@emotion/core';
import { textAlign } from './textAlign';

const Li = ({ attributes, children }) => {
  useEffect(() => {
    const li = attributes.ref.current;
    let _fontFamily = '';

    // we don't care about color per li now
    // global on the field
    //
    let _color = '';
    let lastSpan;

    Array.from(li.querySelectorAll('span')).forEach((span: any) => {
      //
      // totally ignore any links
      if (span.closest('a')) {
        return;
      }

      const { fontFamily, color } = span.style;

      if (fontFamily && !_fontFamily) {
        // set the li font to the first font we encounter
        _fontFamily = fontFamily;
      }

      if (!!color) {
        const childSpanOfSpan = span.querySelector('span');

        if (childSpanOfSpan) {
          childSpanOfSpan.style.color = color;
        }
      }
    });

    // li.style.fontFamily = _fontFamily;
  });

  return (
    <li {...attributes}>
      {/* <span>{children}</span> */}
      {children}
    </li>
  );
};

const renderNode = (props, editor, next) => {
  const { attributes, children, node, isFocused } = props;

  let style;
  try {
    style = props.node.data.toJS().style || {};
  } catch (err) {
    console.warn('!!!');
  }

  switch (node.type) {
    case 'list-item':
      return <Li attributes={attributes}>{children}</Li>;
    // return <li {...attributes}>{children}</li>;

    case 'bulleted-list':
      return (
        <ul className="chameleon-ul" {...attributes}>
          {children}
        </ul>
      );

    case 'numbered-list':
      return (
        <ol className="chameleon-ol" {...attributes}>
          {children}
        </ol>
      );

    case 'indented-list':
      return (
        <ul className="indented-list" {...attributes}>
          {children}
        </ul>
      );

    case 'indented':
      return (
        <div className="indented" style={{ paddingLeft: 20 }} {...attributes}>
          {children}
        </div>
      );

    case 'textAlignLeft':
      return (
        <div className="chameleon-text-align-left" {...attributes}>
          {children}
        </div>
      );

    case 'textAlignCenter':
      return (
        <div className="chameleon-text-align-center" {...attributes}>
          {children}
        </div>
      );

    case 'textAlignRight':
      return (
        <div className="chameleon-text-align-right" {...attributes}>
          {children}
        </div>
      );

    case 'heading-one':
      return (
        <h1 style={style} {...attributes}>
          {children}
        </h1>
      );

    case 'heading-two':
      return (
        <h2 style={style} {...attributes}>
          {children}
        </h2>
      );

    case 'heading-three':
      return (
        <h3 style={style} {...attributes}>
          {children}
        </h3>
      );

    case 'heading-four':
      return (
        <h4 style={style} {...attributes}>
          {children}
        </h4>
      );

    case 'heading-five':
      return (
        <h5 style={style} {...attributes}>
          {children}
        </h5>
      );

    case 'heading-six':
      return (
        <h6 style={style} {...attributes}>
          {children}
        </h6>
      );

    case 'paragraph': {
      return (
        <p style={style} {...attributes}>
          {children}
        </p>
      );
    }

    case 'code': {
      return (
        <pre style={style} {...attributes}>
          <code>{children}</code>
        </pre>
      );
    }

    default:
      return next();
  }
};

export default renderNode;
